import {
  LayoutDashboard, CalendarDays, Car, Users, FileText,
  CreditCard, Wrench, BarChart3, Settings,
} from "lucide-react";

export const NAV_ITEMS = [
  { key: "dashboard", label: "Panel", path: "/dashboard", icon: LayoutDashboard },
  { key: "reservations", label: "Reservas", path: "/reservations", icon: CalendarDays },
  { key: "fleet", label: "Flota", path: "/fleet", icon: Car },
  { key: "customers", label: "Clientes", path: "/customers", icon: Users },
  { key: "contracts", label: "Contratos", path: "/contracts", icon: FileText },
  { key: "payments", label: "Pagos", path: "/payments", icon: CreditCard },
  { key: "maintenance", label: "Mantenimiento", path: "/maintenance", icon: Wrench },
  { key: "reports", label: "Reportes", path: "/reports", icon: BarChart3 },
  { key: "settings", label: "Configuración", path: "/settings", icon: Settings },
];
